import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";

class AddWorkPlanModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: false,
      codeRequiredAlert: false,
      codeAlertText: "",
      code: GC.CodeAutoFill("Planningspatroon"),
      omschrijving: "",
      startenNa: 0,
      maxAantal: "",
      cyclus: 1,
      planningsfrequentie: 1,
      active: true,
      numberList: ["startenNa", "maxAantal", "cyclus", "planningsfrequentie"],
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("Planningspatroon") });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    // negatif değer girilmesini engelliyor.
    if (this.state.numberList.find((x) => x === name)) {
      const re = /^[+]?\d*\.\d+$|^[+]?\d+(\.\d*)?$/;
      // if value is not blank, then test the regex
      if (target.value === "" || re.test(target.value)) {
        this.setState({ [name]: value });
      }
    } else {
      this.setState({
        [name]: value,
      });

      if (value != "" && name == "naam") {
        this.setState({ naamRequiredAlert: false });
      }
    }
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);
    var actief;
    if ($("#werkplan-active").is(":checked")) {
      actief = true;
    } else actief = false;

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });

    var model = {
      relationships: { definition: { code: "PLANNINGSPATROON" } },
      content: {
        algemeen: {
          actief: this.state.active,
          startenna: this.state.startenNa,
          maxaantal: this.state.maxAantal,
          frequentie: this.state.planningsfrequentie,
          omschrijving: this.state.omschrijving,
          naam: this.state.naam,
          code: this.state.code,
          cyclus: this.state.cyclus,
        },
      },
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_PLANNINGSPATRONEN],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      !this.state.naamRequiredAlert &&
      !this.state.codeRequiredAlert &&
      isUnique === true
    ) {
      let result = await omnimap.SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      );
      if (result.result.status === "OK") {
        CallBackFunctions.WerkplanSavedCallBack(
          window.$catalog_management_units_token,
          result.data.identification
        );
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#planningspatroon_toevoegen", async function () {
      $("#planningPattern_toevoegen_modal").modal("show");
      that.resetForm();
    });
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="planningPattern_toevoegen_modal"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Nieuw Planningspatroon</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //**Werkplan Naam */}
                <label
                  className={
                    this.state.naamRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Naam *
                </label>{" "}
                <label
                  className={
                    this.state.naamRequiredAlert
                      ? "modale-submit-alert-block"
                      : "modale-submit-alert-none"
                  }
                >
                  {"\u00A0"} required
                </label>
                <input
                  id="werkplan-naam"
                  type="input"
                  className="form-control"
                  autocomplete="off"
                  name="naam"
                  value={this.state.naam}
                  onChange={this.handleInputChange}
                />
                {/* //**Werkplan Code */}
                <label
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Code *
                </label>
                <label
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : "modale-submit-alert-none"
                  }
                >
                  {"\u00A0"} {this.state.codeAlertText}
                </label>
                <input
                  id="werkplan-code"
                  type="input"
                  className="form-control"
                  placeholder="Code"
                  autocomplete="off"
                  name="code"
                  value={this.state.code}
                  onChange={this.handleInputChange}
                />
                <label
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Omschrijving
                </label>
                <input
                  type="input"
                  className="form-control"
                  autocomplete="off"
                  name="omschrijving"
                  value={this.state.omschrijving}
                  onChange={this.handleInputChange}
                />
                <label
                  data-toggle="tooltip"
                  title="Voorbeeld: Bij een waarde van 3 wordt pas na drie jaar met het onderhoud begonnen."
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Starten Na
                </label>
                <input
                  id="werkplan-code"
                  type="text"
                  className="form-control"
                  autocomplete="off"
                  name="startenNa"
                  min="0"
                  value={this.state.startenNa}
                  onChange={this.handleInputChange}
                />
                <label
                  data-toggle="tooltip"
                  title="Het maximaal aantal keer dat onderhoud wordt uitgevoerd"
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Max Aantal
                </label>
                <input
                  id="werkplan-code"
                  type="text"
                  className="form-control"
                  autocomplete="off"
                  name="maxAantal"
                  value={this.state.maxAantal}
                  onChange={this.handleInputChange}
                />
                <label
                  data-toggle="tooltip"
                  title="Voorbeeld: Indien hier 5 is ingevuld, wordt het onderhoud eens in de vijf jaar gedaan."
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Cyclus
                </label>
                <input
                  id="werkplan-code"
                  type="text"
                  className="form-control"
                  autocomplete="off"
                  name="cyclus"
                  value={this.state.cyclus}
                  onChange={this.handleInputChange}
                />
                <label
                  data-toggle="tooltip"
                  title="Aantal keer dat het onderhoudswerk uitgevoerd wordt binnen de opgegeven cyclus"
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Planningsfrequentie
                </label>
                <input
                  id="werkplan-code"
                  type="text"
                  className="form-control"
                  autocomplete="off"
                  name="planningsfrequentie"
                  value={this.state.planningsfrequentie}
                  onChange={this.handleInputChange}
                />
                {/* //**Werkplan Actief */}
                <label>Actief</label>
                <label className="switch">
                  <input
                    id="werkplan-active"
                    type="checkbox"
                    defaultChecked
                    name="active"
                    value={this.state.active}
                    onChange={this.handleInputChange}
                  />
                  <span className="slider-checkbox round" />
                </label>
                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplann"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddWorkPlanModal;
